import React from "react";
import clsx from "clsx";

import Container from "@components/Atomic/Container/Container";
import { Container as UIContainer } from "@bared/ui";

import { withTextGrid } from "./withTextGrid";

const width = {
  0: "w-full md:w-1/2",
  1: "w-full md:w-1/2",
  2: "w-full md:w-1/2",
  3: "w-full md:w-1/3",
  4: "w-full md:w-1/2 lg:w-1/4",
  5: "w-full md:w-1/2 lg:w-1/5",
  6: "w-full md:w-1/2 lg:w-1/6",
  7: "w-full md:w-1/2 lg:w-1/7",
  8: "w-full md:w-1/2 lg:w-1/8",
  9: "w-full md:w-1/2 lg:w-1/9",
  10: "w-full md:w-1/2 lg:w-1/10",
  11: "w-full md:w-1/2 lg:w-1/11",
  12: "w-full md:w-1/2 lg:w-1/12",
};

const TextGrid = withTextGrid(({ contents, styles }) => (
  <Container
    styles={styles}
    legacy={!styles?.length}
    data-component-type="section-text-grid"
  >
    {contents && contents.length > 0 ? (
      <UIContainer maxWidth="2xl" className="flex flex-wrap">
        {contents.map((content, index) => (
          <div
            className={clsx(
              "flex md:px-maxi",
              width[contents.length as keyof typeof width],
            )}
            key={index}
          >
            <div
              className={clsx(
                content.desktopAlignment
                  ? content.desktopAlignment === "left"
                    ? "[&>*]:text-left [&_img]:mx-zero"
                    : "[&>*]:text-center"
                  : null,
                content.mobileAlignment
                  ? content.desktopAlignment === "left"
                    ? "[&>*]:text-left [&_img]:mx-zero"
                    : "[&>*]:text-center"
                  : null,
                "rte",
              )}
            >
              {content?.content}
            </div>
          </div>
        ))}
      </UIContainer>
    ) : null}
  </Container>
));

export default TextGrid;
